import { Box, Grid, Paper, Typography } from "@mui/material"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faFileAlt, faUser, faUserCheck, faUsers } from '@fortawesome/free-solid-svg-icons';
import { BreadCrumbCustom } from '../../components/BreadCrumbCustom/BreadCrumbCustom';
import { useLang } from '../../language';

import './index.scss'
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { isColegiado, isPreColegiado } from "../../routes/helpers";

export const Dashboard = () => {

    const Lang = useLang()

    const { auth } = useSelector((state: RootState) => state.auth)

    const BreadcrumbLineItems = [
        {
            title: Lang('MI_COLEGIO'),
            link: '/el-meu-col-legi'
        }
    ]

    const [htmlContent, setHtmlContent] = useState("");

    useEffect(() => {

        // @ts-ignore
        window.username = auth?.username;
        // @ts-ignore
        window.accion = 'checkExistePersonaCenso';

        const url = `${process.env.PUBLIC_URL}/elecciones/elecciones.php?v=${new Date().getTime()}`;

        fetch(url)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                // Eliminar scripts previamente creados
                document.querySelectorAll(".dynamic-script").forEach(script => script.remove());

                // Copiar los estilos del HTML al documento principal
                const styles = doc.querySelectorAll("link[rel='stylesheet'], style");
                styles.forEach(style => {
                    document.head.appendChild(style.cloneNode(true)); // Clona los estilos
                });

                // Extraer los scripts antes de inyectar el HTML
                const scripts = Array.from(doc.querySelectorAll("script")).map(script => script.textContent);

                // Inyectar el contenido HTML
                setHtmlContent(doc.body.innerHTML);

                // Ejecutar los scripts después de renderizar el HTML
                setTimeout(() => {
                    // console.log('Ejecutando los scripts...');
                    scripts.forEach((scriptContent, index) => {
                        const newScript = document.createElement("script");
                        newScript.textContent = scriptContent;
                        newScript.classList.add("dynamic-script"); // Agregar clase identificadora
                        document.body.appendChild(newScript);

                        // Agregar evento de verificación para los scripts
                        if (index === scripts.length - 1) {
                            // console.log('Último script ejecutado');
                            // Intentamos emitir el evento `DOMContentLoaded` manualmente si es necesario
                            const event = new Event("DOMContentLoaded");
                            document.dispatchEvent(event);
                        }
                    });
                }, 200); // Damos tiempo a React para actualizar el DOM
            })
            .catch(error => console.error("Error cargando el HTML:", error));
    }, []);


    return (

        <div className='ContainerDashboard'>

            {/* <div className='ContainerDashboard__background'>
                <img src={getImage('./edifici.jpg')} alt="" id='' />
            </div> */}

            <BreadCrumbCustom items={BreadcrumbLineItems} />

            <section className='LayoutPrimary__contentmain grow-1 px-3 py-5 px-lg-5 py-lg-5'>

                <Box>
                    <Grid container spacing={3} justifyContent="center" >

                        {
                            (isColegiado(auth?.rol) || isPreColegiado(auth?.rol)) ?

                                <Grid item xs={12} md={12} lg={12} xl={12} className='mb-2 pb-2 pt-0'>

                                    <Grid item xs={12} className='mb-2 pb-2 pt-0'>

                                        <Paper sx={{ width: '100%', maxWidth: '100%' }} className='DashboardCard mx-auto mt-0'>

                                            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                                            {/* <iframe
                                        src={`${process.env.PUBLIC_URL}/elecciones/elecciones.html?v=${(new Date().getTime())}`}
                                        width="100%"
                                        height="1150px"
                                        title="Iframe Example"
                                        className="border-0"
                                    ></iframe> */}
                                        </Paper>

                                    </Grid>
                                </Grid>
                                :

                                <Grid item xs={12} md={10} lg={10} xl={8} className='mb-2 pb-2'>

                                    <Grid item xs={12} className='mb-2 pb-2 '>

                                        <Paper sx={{ width: '100%', maxWidth: '100%' }} className='DashboardCard mx-auto'>

                                            <div className="DashboardCard__header p-3">
                                                <Typography variant='h6' className="my-0 fw-500 color-primary-2 text-center">
                                                    BENVINGUT A EL MEU COL·LEGI, EL NOU ESPAI WEB D'ENGINYERS BCN
                                                </Typography>
                                            </div>

                                            <div className="DashboardCard__body p-3 pt-4">

                                                <div className="Item__info d-flex">
                                                    <div className='Item__icon'>
                                                        <FontAwesomeIcon icon={faUser} className='color-primary' />
                                                    </div>
                                                    <Typography variant='body1' className="my-0 pb-3 fw-500">
                                                        Accedeix a les plataformes del col·legi que tens disponibles, mitjançant el menú lateral. Plega'l o desplega'l en funció de les teves necessitats.
                                                    </Typography>
                                                </div>

                                                <div className="Item__info d-flex">
                                                    <div className='Item__icon'>
                                                        <FontAwesomeIcon icon={faUsers} className='color-primary' />
                                                    </div>
                                                    <Typography variant='body1' className="my-0 pb-3 fw-500">
                                                        Gestiona les teves dades. Si ets col·legiat, dona't d'alta o modifica el teu perfil a la Guia de professionals i el Registre de Certificadors d'Eficiència Energètica en Edificis.
                                                    </Typography>
                                                </div>

                                                <div className="Item__info d-flex">
                                                    <div className='Item__icon'>
                                                        <FontAwesomeIcon icon={faFileAlt} className='color-primary' />
                                                    </div>
                                                    <Typography variant='body1' className="my-0 pb-3 fw-500">
                                                        Descarrega't els Segells del col·legi, sol·licita un certificat de col·legiació o un duplicat del teu carnet de col·legiat.
                                                    </Typography>
                                                </div>

                                                <div className="Item__info d-flex">
                                                    <div className='Item__icon'>
                                                        <FontAwesomeIcon icon={faCopy} className='color-primary' />
                                                    </div>
                                                    <Typography variant='body1' className="my-0 pb-3 fw-500">
                                                        Localitza tota la documentació de manera àgil, fent servir el cercador per paraula clau o el sistema de carpetes i subcarpetes, segons el tema. El nou Cercador de documentació i coneixement també inclou les preguntes freqüents amb les respostes generades pels diferents serveis.
                                                    </Typography>
                                                </div>

                                                <div className="Item__info d-flex">
                                                    <div className='Item__icon'>
                                                        <FontAwesomeIcon icon={faUserCheck} className='color-primary' />
                                                    </div>
                                                    <div>
                                                        <Typography variant='body1' className="my-0 pb-0 fw-500">
                                                            Ara realitzar les teves gestions amb el Col·legi és molt senzill.
                                                        </Typography>
                                                        <Typography variant='body1' className="my-0 pb-3 fw-500">
                                                            I si tens cap consulta, posa’t en contacte amb nosaltres a <a href="mailto:ebcn@ebcn.cat" className='color-primary'>ebcn@ebcn.cat</a>
                                                        </Typography>
                                                    </div>
                                                </div>

                                            </div>

                                        </Paper>

                                    </Grid>
                                </Grid>
                        }

                    </Grid>
                </Box>
            </section>
        </div>
    )
}
